import { render } from "./organizational-table.vue?vue&type=template&id=2c4b51dc"
import script from "./organizational-table.vue?vue&type=script&lang=js"
export * from "./organizational-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__